import { render, staticRenderFns } from "./CourseModule.vue?vue&type=template&id=c4081b02&scoped=true"
import script from "./CourseModule.vue?vue&type=script&lang=js"
export * from "./CourseModule.vue?vue&type=script&lang=js"
import style0 from "./CourseModule.vue?vue&type=style&index=0&id=c4081b02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4081b02",
  null
  
)

export default component.exports